export default __webpack_public_path__ + "media/images/ciat-2082da2844b444dfc2a03b1b14f8ca0e.png";